/* eslint-disable react-hooks/exhaustive-deps */
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import CommonToast from "../../../../components/_utils/CommonToast";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent";
import CommonTransactionApprovalCard from "../../../../components/_utils/CommonTransactionApprovalCard";
import FormatAmount from "../../../../components/_utils/FormatAmount/FormatAmount";
import PaginationComponent from "../../../../components/_utils/PaginationComponent";
import TimelinePopupContent from "../../../../components/_utils/TimelinePopupContent";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast";
import { addLifeCycleStatus } from "../../../../components/CommonTimeLineCard";
import Loader from "../../../../components/Loader/Index";
import BeneficiaryTransactionDetailsPopup from "../../../../components/Transactions/BeneficiaryTransaction/BeneficiaryTransactionDetailsPopup/index.jsx";
import { getAllBeneficiaryAccounts } from "../../../../redux/features/accounts/beneficiaryAccount/index.js";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import {
  ownerAccountsBalanceRefresh,
  ownerAccountsViewAll,
  setshowsuccestoast,
} from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import { getAllCategories } from "../../../../redux/features/sharedResources/sharedResources";
import {
  beneficiaryTransactionsAddLabel,
  beneficiaryTransactionsDetailsById,
  beneficiaryTransactionsRemoveLabel,
  beneficiaryTransactionsViewAll,
} from "../../../../redux/features/transactions/beneficiaryTransactions/index.js";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider";
import { standardAccountNumberFormat } from "../../../../utils/standardAccountNumberFormat";
import SmallPopupWithBulletPoints from "../../../../components/_utils/CommonSmallPopupWithBulletPoint/index.jsx";
import {
  getOutsideBankingHoursLabel,
  isOutsideBankingHours,
} from "../../../../utils/bankingHours.js";
import CommonAlertCard from "../../../../components/_utils/CommonAlertCard/index.jsx";
import UseHandleScroll from "../../../../hooks/useHandleScroll";

const BeneficiaryTransactionRecreateDashboard = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const filterRef = useRef(null);

  const { isDashboradCheck, startDateLocationState, endDateLocationState } =
    location.state || {};

  const scrollRef = useRef(null);
  const labelActionDispatchedRef = useRef(false);

  const getDefaultWeekSpan = () => {
    const today = dayjs();
    const weekAgo = today.subtract(6, "days");
    return [weekAgo.toDate(), today.toDate()];
  };

  const getWeekSpan = () => {
    const currentDate = dayjs(Date.now());
    const weekAgo = currentDate.subtract(6, "days");

    return [weekAgo.toDate(), currentDate.toDate()];
  };

  const getLastNDaysRange = (n = 7) => {
    const days = Number(n) || 7;
    return {
      startDate: dayjs()
        .subtract(days - 1, "day")
        .startOf("day")
        .unix(),
      endDate: dayjs().endOf("day").unix(),
    };
  };

  const [startDate, setStartDate] = useState(() => {
    if (startDateLocationState) return new Date(startDateLocationState * 1000);
    return getDefaultWeekSpan()[0];
  });
  const [endDate, setEndDate] = useState(() => {
    if (endDateLocationState) return new Date(endDateLocationState * 1000);
    return getDefaultWeekSpan()[1];
  });
  const [dropdownOptions] = useState(PaginationConfiguration.paginationOptions);
  const [selectedValue, setSelectedValue] = useState(
    PaginationConfiguration.paginationSmall,
  );
  const [storedPage] = useState(GlobalConfiguration.lengthCheckOne);
  const [, setTotalPages] = useState(GlobalConfiguration.lengthCheckZero);
  const [mainData, setMainData] = useState([]);
  const [currentPage, setCurrentPage] = useState(
    GlobalConfiguration.lengthCheckOne,
  );
  const [totalCount, setTotalCount] = useState(
    GlobalConfiguration.lengthCheckZero,
  );
  const [allScheduleTxnAccountsLoading, setAllScheduleTxnAccountsLoading] =
    useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [pageSize, setPageSize] = useState(
    PaginationConfiguration.paginationSmall,
  );
  const [currentStatus] = useState("all");
  const [startDateFilter, setStartDateFilter] = useState(
    startDateLocationState ?? "",
  );
  const [endDateFilter, setEndDateFilter] = useState(
    endDateLocationState ?? "",
  );
  const [createdVia, setCreatedVia] = useState("");

  const handleCreatedVia = (createdVia) => {
    setCreatedVia(createdVia);
  };

  const [isPaymentMethod, setIsPaymentMethod] = useState("");
  const [txnPayLoad, setTxnPayLoad] = useState({
    bankAccountName: "",
    beneAccountId: "",
    bankAccountNo: "",
    bankAccountIFSC: "",
    ownerAccountId: "",
    amount: "",
    ownerbankAccountNo: "",
  });
  const [accumulatedData, setAccumulatedData] = useState([]);
  const [txnAmountFilter, setTxnAmountFilter] = useState("");
  const [, setHideCaroursal] = useState(false);

  const [isSidebarOpen] = useState(false);
  const [, setIsFilterApplied] = useState(false);

  const [paymentMethod, setPaymentMethod] = useState("");

  const [accountNumber, setAccountNumber] = useState(
    txnPayLoad?.bankAccountNo ? txnPayLoad?.bankAccountNo : "",
  );
  const [accountName, setAccountName] = useState(
    txnPayLoad?.bankAccountName ? txnPayLoad?.bankAccountName : "",
  );

  const [showBankingHoursPopup, setShowBankingHoursPopup] = useState(false);
  const isOutsideBankingHoursNow = isOutsideBankingHours();

  const totalTransactionCount = Number(mainData?.total_count || 0);

  const hasPendingTransaction = accumulatedData?.some(
    (transaction) => transaction?.lifecycle_status === "pending",
  );

  const hasPendingBeneficiaryAccount = accumulatedData?.some(
    (transaction) =>
      transaction?.beneficiary_account_approval_status === "pending",
  );

  const shouldShowTransactionBankingHoursAlert =
    totalTransactionCount > 0 &&
    hasPendingTransaction &&
    isOutsideBankingHoursNow;

  const shouldShowAccountBankingHoursAlert =
    totalTransactionCount > 0 &&
    hasPendingBeneficiaryAccount &&
    isOutsideBankingHoursNow;

  const shouldShowBankingHoursAlert =
    shouldShowTransactionBankingHoursAlert ||
    shouldShowAccountBankingHoursAlert;

  const [txnAddDetails, setTxnAddDetails] = useState("");
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [showRefactorDetailPop, setShowRefactorDetailPop] = useState(false);
  const [loading] = useState(false);
  const [currentCategory, setCurrentCategory] = useState("");
  const [displayCategory, setDisplayCategory] = useState("");
  const [selectedBeneAccId, setSelectedBeneAccId] = useState(
    props?.bene_account_id ? props?.bene_account_id : "",
  );
  const [selectedOwnerAccId, setSelectedOwnerAccId] = useState(
    props?.Owner_account_id ? props?.Owner_account_id : "",
  );
  const [isConfidentialMethod, setIsConfidentialMethod] = useState(
    props?.bene_account_confidential === "Y"
      ? "Show only confidential"
      : props?.bene_account_confidential === "N"
        ? "Hide confidential"
        : (props?.bene_account_confidential ?? ""),
  );
  const [confidentialMethod, setConfidentialMethod] = useState(
    props?.bene_account_confidential === "Y"
      ? "Show only confidential"
      : props?.bene_account_confidential === "N"
        ? "Hide confidential"
        : (props?.bene_account_confidential ?? ""),
  );
  const [OpenTimeLinePopup, SetOpenTimeLinePopup] = useState(false);
  const [txnId, setTxnId] = useState(null);
  const [txnAmount, setTxnAmount] = useState("");
  const [txnSearchType, setTxnSearchType] = useState("");
  const [accountNameValue, setAccountNameValue] = useState("");
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [searchUserText, setSearchUserText] = useState("");
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [active, setActive] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [inputData, setInputData] = useState([]);
  const [labelTxnId, setLabelTxnId] = useState([]);
  const [labels, setLabels] = useState([]);
  const [labelsFilter, setFilterLabels] = useState([]);
  const [, setSelectedLabels] = useState([]);
  const [labelPopupLoading, setLabelPopupLoading] = useState(false);
  const [isLabelPopupOpen, setIsLabelPopupOpen] = useState(false);

  const [timelineLoading, setTimelineLoading] = useState(false);
  const [timelineTxnDetails, setTimelineTxnDetails] = useState([]);
  const [, setTimelineTxnId] = useState(null);
  const [openApprovalTimeline, setOpenApprovalTimeline] = useState([]);
  const [openDistributionTimeline, setOpenDistributionTimeline] = useState([]);

  const [direction, setDirection] = useState("");
  const lastScrollTop = useRef(GlobalConfiguration.lengthCheckZero);
  const { handleScroll } = UseHandleScroll(
    setDirection,
    lastScrollTop,
    GlobalConfiguration.beneTxnReCreateDashCardHeight,
  );

  const services = useSelector((state) => state.refreshToken.services);
  const hasModService = services?.includes("CBeneficiaryTxn");

  const { ownerAccBalanceLoading, ownerAccBalanceError } = useSelector(
    (state) => state.ownerAllVerification,
  );
  const allCategories = useSelector(
    (state) => state.sharedResources?.categoriesData?.categories,
  );
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  const dispatch = useDispatch();

  const handleAction = async () => {
    try {
      setAllScheduleTxnAccountsLoading(true);

      let queryParams = {
        page_no: currentPage,
        page_item_count: pageSize,
        lifecycle_status: "rejected",
        refactor: false,
      };

      const addParamsBasedOnSelection = () => {
        if (currentCategory && currentCategory !== "Select category") {
          queryParams.category_id = currentCategory;
        }
        if (
          startDate &&
          endDate &&
          !isNaN(Number(startDate)) &&
          !isNaN(Number(endDate))
        ) {
          queryParams.start_date = Math.floor(startDate.getTime() / 1000);
          queryParams.end_date = Math.floor(endDate.getTime() / 1000);
        }
        if (labelsFilter?.length && labelsFilter !== "Select labels") {
          queryParams.labels = labelsFilter;
        }
        if (isPaymentMethod) {
          queryParams.payment_method = isPaymentMethod;
        }
        if (isConfidentialMethod) {
          queryParams.confidential_transaction = isConfidentialMethod;
        }

        if (txnAddDetails.trim() !== "") {
          queryParams.additional_data = txnAddDetails.trim();
        }
        if (txnAmountFilter !== "") {
          queryParams.amount = txnAmountFilter;
        }
        if (selectedBeneAccId !== "") {
          queryParams.beneficiary_account_id = selectedBeneAccId;
        }
        if (selectedOwnerAccId !== "") {
          queryParams.owner_account_id = selectedOwnerAccId;
        }
      };
      addParamsBasedOnSelection();

      const response = await dispatch(
        beneficiaryTransactionsViewAll(queryParams),
      );
      const newData = response?.payload?.transactions || [];

      setMainData(response?.payload);
      setAccumulatedData(newData);

      setTotalCount(response?.payload?.total_count || 0);
    } catch (error) {
      console.error("Error in API call:", error);
      setMainData([]);
      setAccumulatedData([]);
    } finally {
      setAllScheduleTxnAccountsLoading(false);
    }
  };

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
    setTxnSearchType("additional");
  };

  const handleConfidentialMethod = (selectedConfidential) => {
    setIsConfidentialMethod(selectedConfidential);
  };

  const handlePaymentMethod = (selectedSettlement) => {
    setIsPaymentMethod(selectedSettlement);
  };
  const handleFilterDateRange = (startDate, endDate) => {
    setStartDateFilter(startDate);
    setEndDateFilter(endDate);
  };

  const handlePagination = (page) => {
    setCurrentPage(page);
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleSelect = (value) => {
    setSelectedValue(value);
    setPageSize(value);
    setCurrentPage(Number(storedPage) || currentPage);
    toggleDropdown();
  };

  const handleClearParams = (e) => {
    e?.stopPropagation();

    // Reset filters
    setTxnAmount("");
    setTxnAddDetails("");
    setTxnAmountFilter("");

    setCurrentCategory("");

    setIsPaymentMethod("");
    setPaymentMethod("");

    setIsConfidentialMethod("");
    setConfidentialMethod("");

    setSelectedBeneAccId("");
    setAccountName("");

    setSelectedOwnerAccId("");
    setAccountNumber("");
    setFilterLabels([]);
    setSearchUserText("");

    setSearchUserTextDebounce("");
    setShowSearchBar(false);

    // Reset payload
    setTxnPayLoad((prev) => ({
      ...prev,
      amount: "",
      ownerbankAccountNo: "",
      ownerAccountId: "",
    }));

    const [defaultStart, defaultEnd] = getDefaultWeekSpan();
    setStartDate(defaultStart);
    setEndDate(defaultEnd);
    setStartDateFilter(Math.floor(defaultStart.getTime()));
    setEndDateFilter(Math.floor(defaultEnd.getTime()));

    // Reset pagination
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
  };

  const openRefactorTxnDetailModal = (txnId) => {
    setShowRefactorDetailPop(true);
  };

  const closeRefactorTxnDetailModal = () => {
    setShowRefactorDetailPop(false);
  };

  const hasAnyFilter =
    Boolean(currentCategory) ||
    Boolean(labelsFilter?.length) ||
    Boolean(accountNumber?.length) ||
    Boolean(searchUserText?.length) ||
    Boolean(txnAddDetails?.length) ||
    Boolean(isPaymentMethod) ||
    Boolean(isConfidentialMethod) ||
    Boolean(txnAmountFilter) ||
    Boolean(selectedBeneAccId) ||
    Boolean(selectedOwnerAccId) ||
    (startDateFilter !== "" &&
      endDateFilter !== "" &&
      startDateFilter !== GlobalConfiguration.lengthCheckZero &&
      endDateFilter !== GlobalConfiguration.lengthCheckZero &&
      !isNaN(Number(startDateFilter)) &&
      !isNaN(Number(endDateFilter)) &&
      !(
        dayjs(Number(startDateFilter)).isSame(
          dayjs().subtract(6, "day"),
          "day",
        ) && dayjs(Number(endDateFilter)).isSame(dayjs(), "day")
      )) ||
    Boolean(searchUserTextDebounce?.length);

  const noTransactionsFromAPI =
    !allScheduleTxnAccountsLoading &&
    mainData &&
    mainData.total_count === GlobalConfiguration.lengthCheckZero &&
    !hasAnyFilter;

  const noResultsAfterFilter =
    !allScheduleTxnAccountsLoading &&
    accumulatedData?.length === GlobalConfiguration.lengthCheckZero &&
    hasAnyFilter;

  const emptyStateButton = noResultsAfterFilter
    ? {
        btnText: "Clear parameters",
        handleFunction: handleClearParams,
        enabledBgColor: "var(--primary-nav-act)",
      }
    : {
        btnText: "Go to dashboard",
        handleFunction: () => navigate("/beneficiary_transaction_dashboard"),
        enabledBgColor: "var(--primary-act)",
      };

  const openTimelineModal = async (txnId) => {
    setTimelineTxnDetails([]);
    setTimelineTxnId(txnId);
    SetOpenTimeLinePopup(true);
    setTimelineLoading(true);

    const res = await dispatch(
      beneficiaryTransactionsDetailsById({
        id: txnId,
      }),
    );

    if (res?.payload?.transaction) {
      const uiState = addLifeCycleStatus({
        lifecycle_status:
          res.payload.transaction[GlobalConfiguration.lengthCheckZero]
            ?.lifecycle_status,
        distribution_lifecycle_status:
          res.payload.transaction[GlobalConfiguration.lengthCheckZero]
            ?.distribution_lifecycle_status,
        services,
      });
      setTimelineTxnDetails([
        {
          ...res.payload.transaction[GlobalConfiguration.lengthCheckZero],
          ...uiState,
        },
      ]);
    }

    setTimelineLoading(false);
  };
  const handleRefresh = async (e, id, prevBalance) => {
    e.stopPropagation();
    try {
      let response = await dispatch(ownerAccountsBalanceRefresh(id));

      if (response?.payload?.status === true) {
        let data = accumulatedData?.map((item) => {
          if (
            response?.payload.owner_accounts[0].owner_account_id ===
            item.owner_account_id
          ) {
            return {
              ...item,
              owner_account_balance_last_fetched_at_in_words:
                response.payload.owner_accounts[0]
                  .owner_account_balance_last_fetched_at_in_words,
              owner_account_balance:
                response.payload.owner_accounts[0].owner_account_balance,

              owner_account_balance_last_fetched_at:
                response.payload.owner_accounts[0]
                  .owner_account_balance_last_fetched_at,
            };
          }
          return item;
        });
        setAccumulatedData(data);
        setTimeout(() => {
          CommonToast({
            text: "Balance refreshed successfully.",
            icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
            variant: "var(--success)",
          });
          dispatch(setshowsuccestoast());
        }, 250);
      } else {
        setTimeout(() => {
          toast.dismiss();
          const errorMessage =
            response?.payload?.response?.data?.errors?.base?.[
              GlobalConfiguration.lengthCheckZero
            ] || response?.payload?.message;

          CommonToast({
            text: errorMessage,
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
          });
        }, 500);
      }
    } catch (error) {
      CommonToast({
        text: error,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      throw error;
    }
  };

  const fetchData = async () => {
    setLoadingData(true);

    let response;
    let data = [];

    try {
      switch (active) {
        case "Beneficiary account":
          response = await dispatch(
            getAllBeneficiaryAccounts({
              search_string: searchUserTextDebounce,
              page_no: 1,
              page_size: 5,
            }),
          );
          if (response?.payload?.status) {
            data =
              response.payload.beneficiary_accounts?.map((itm) => ({
                id: itm.id,
                Name: itm.name,
                Account_number: itm.bank_acc_no,
                display: itm.name,
                IFSC_code: itm.ifsc_code,
                Contact_number: itm.contact_no,
                Email_ID: itm.email_id,
              })) || [];
          }
          break;

        case "Owner account":
          response = await dispatch(
            ownerAccountsViewAll({
              search_string: searchUserTextDebounce,
              page_no: 1,
              page_size: 5,
            }),
          );
          if (response?.payload?.status) {
            data =
              response.payload.owner_accounts?.map((itm) => ({
                id: itm.id,
                Account_number: itm.bank_acc_no,
                display: itm.bank_acc_no,
                Name: itm.name,
                IFSC_code: itm.ifsc_code,
                Email_ID: itm.email_id,
              })) || [];
          }
          break;

        case "Category":
          response = await dispatch(
            getAllCategories({ search_string: searchUserTextDebounce }),
          );
          data =
            response?.payload?.categories?.map((itm) => ({
              id: itm.id,
              Category: itm.name,
              Description: itm?.description || "Not given",
            })) || [];
          break;

        case "Labels": {
          const normalizedSearch = (searchUserTextDebounce || "")
            .toLowerCase()
            .trim();

          const availableLabels =
            JSON.parse(
              sessionStorage.getItem("beneficiaryTxnLabels") || "[]",
            ) || labels;
          data =
            availableLabels
              ?.filter((label) =>
                (label || "").toLowerCase().includes(normalizedSearch),
              )
              ?.map((val) => ({
                id: val,
                Label: val,
              })) || [];
          break;
        }

        case "Search":
          setSearchUserText(searchUserTextDebounce);
          setLoadingData(false);
          break;

        default:
          data = [];
          setLoadingData(false);
          break;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      data = [];
    } finally {
      setInputData([...data]);
      setLoadingData(false);
    }
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message;
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleClose = () => {
    setIsLabelPopupOpen(false);
    if (!labelActionDispatchedRef.current) return;
    labelActionDispatchedRef.current = false;
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setLabelPopupLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const recordIds = toArray(labelTxnId);
    const res = await dispatch(
      beneficiaryTransactionsAddLabel({
        record_ids: recordIds,
        labels: labelsToAssign,
      }),
    );
    if (beneficiaryTransactionsAddLabel.fulfilled.match(res)) {
      setTimeout(() => {
        toast.dismiss();
        CommonToast({
          text: "Labels assigned successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }, IntervalConfiguration.intervalExtraLarge);
      await handleAction();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (beneficiaryTransactionsAddLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLabelPopupLoading(false);
    if (beneficiaryTransactionsAddLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLabelPopupLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds = toArray(labelTxnId);
    const res = await dispatch(
      beneficiaryTransactionsRemoveLabel({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );
    if (beneficiaryTransactionsRemoveLabel.fulfilled.match(res)) {
      setTimeout(() => {
        toast.dismiss();
        CommonToast({
          text: "Labels unassigned successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }, IntervalConfiguration.intervalExtraLarge);
      await handleAction();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (beneficiaryTransactionsRemoveLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLabelPopupLoading(false);
  };

  useEffect(() => {
    if (isDashboradCheck && startDateLocationState && endDateLocationState) {
      setStartDate(new Date(startDateLocationState * 1000));
      setEndDate(new Date(endDateLocationState * 1000));
      return;
    }

    const { startDate: defaultStart, endDate: defaultEnd } =
      getLastNDaysRange(7);
    setStartDate(new Date(defaultStart * 1000));
    setEndDate(new Date(defaultEnd * 1000));
  }, [isDashboradCheck, startDateLocationState, endDateLocationState]);

  useEffect(() => {
    if (startDate === "" || endDate === "") {
      const [c, w] = getWeekSpan();
      setStartDate(c);
      setEndDate(w);
    }
  }, [startDate, endDate]);

  const updateIsFilterApplied = () => {
    setIsFilterApplied(
      !!currentCategory ||
        !!isPaymentMethod ||
        !!selectedBeneAccId ||
        !!txnAmountFilter ||
        !!selectedOwnerAccId ||
        !!isConfidentialMethod,
      !!labelsFilter?.length || !!txnAddDetails,
    );
  };

  useEffect(() => {
    dispatch(enableSwitcher());
    return () => {
      dispatch(disableSwitcher());
    };
  }, []);

  useEffect(() => {
    handleAction();
  }, [
    markerData,
    currentPage,
    pageSize,
    isPaymentMethod,
    currentStatus,
    endDateFilter,
    startDateFilter,
    txnAmount,
    txnAddDetails,
    txnAmountFilter,
    currentCategory,
    isConfidentialMethod,
    selectedBeneAccId,
    selectedOwnerAccId,
    labelsFilter,
  ]);
  useEffect(() => {
    const newTotalPages = Math.ceil(totalCount / pageSize);
    setTotalPages(newTotalPages);

    setCurrentPage((prevPage) => {
      if (newTotalPages === 0) {
        return 1;
      }
      if (prevPage > newTotalPages) {
        return newTotalPages;
      }
      return prevPage;
    });
  }, [totalCount, pageSize]);

  useEffect(() => {
    if (ownerAccBalanceLoading) {
      UniversalRefreshToast();
    }
    if (!ownerAccBalanceLoading && !ownerAccBalanceError) {
      setTimeout(() => {
        toast.dismiss();
      }, 150);
    }
  }, [ownerAccBalanceLoading]);

  useEffect(() => {
    updateIsFilterApplied();
  }, [
    currentCategory,
    startDateFilter,
    endDateFilter,
    txnAmountFilter,
    isPaymentMethod,
    selectedBeneAccId,
    selectedOwnerAccId,
    isConfidentialMethod,
    labelsFilter,
    txnAddDetails,
  ]);

  useEffect(() => {
    if (scrollRef) {
      if (scrollRef?.current?.scrollWidth > scrollRef?.current?.clientWidth) {
        setHideCaroursal(true);
      } else {
        setHideCaroursal(false);
      }
    }
  }, [
    currentCategory,
    startDateFilter,
    endDateFilter,
    selectedBeneAccId,
    isPaymentMethod,
    accountNumber,
    txnAmountFilter,
    isConfidentialMethod,
  ]);

  useEffect(() => {
    if (active?.length) {
      fetchData();
    }
  }, [active]);

  useEffect(() => {
    if (isLabelPopupOpen) {
      let availableLabels = sessionStorage?.getItem("beneficiaryTxnLabels");
      const parsedLabels = JSON?.parse(availableLabels);
      setLabels(parsedLabels);
    }
  }, [isLabelPopupOpen]);

  return (
    <>
      {showBankingHoursPopup && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop bg-opacity-dark-opacity justify-center z-z-index-modal">
          <SmallPopupWithBulletPoints
            headerTitle="Why transaction cannot be processed?"
            headerFontWeight="semibold"
            headerFontColor="negative-act"
            textSize="font-md"
            bulletPoints={[
              `Any transaction created or approved after banking hours i.e. between ${getOutsideBankingHoursLabel()} will be processed on the next bank working day.`,
              "Payments are time-critical (e.g., salary, vendor payment, or bill payment), consider the possible processing delay before proceeding.",
            ]}
            closeIconImage={ICONS?.CLOSE}
            closeModal={() => setShowBankingHoursPopup(false)}
          />
        </div>
      )}
      {showRefactorDetailPop && (
        <div
          // className="fixed top-top-base left-left-base w-screen h-screen z-z-index-max bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={() => {
            closeRefactorTxnDetailModal();
          }}
        >
          <BeneficiaryTransactionDetailsPopup
            closeBeneTxnDetailModal={closeRefactorTxnDetailModal}
            bene_txn_id={txnId}
            type={"bene_txn_detail_modal"}
            typeSingle={"Additional_Details"}
          />
        </div>
      )}
      {OpenTimeLinePopup && (
        // <div className="fixed top-top-base left-left-base w-screen h-screen z-max-zindex bg-PopUp-BackDrop bg-opacity-dark-opacity">
        <LargePopupRedirect
          headerTitle="Transaction timeline"
          closeiconhandleFunction={() => {
            SetOpenTimeLinePopup(false);
            setTimelineTxnId(null);
            setTimelineTxnDetails([]);
          }}
          isscrollRequired={true}
        >
          {timelineLoading ? (
            <div className="flex justify-center items-center w-full py-padding-xl h-full">
              <Loader />
            </div>
          ) : timelineTxnDetails.length >
            GlobalConfiguration.lengthCheckZero ? (
            <TimelinePopupContent
              logsData={timelineTxnDetails}
              showDistributionRightIcon={false}
              showApprovalLeftIcon={false}
              showApprovalTimeline={true}
              showDistributionTimeline={true}
              openApprovalTimeline={openApprovalTimeline}
              openDistributionTimeline={openDistributionTimeline}
              setOpenApprovalTimeline={setOpenApprovalTimeline}
              setOpenDistributionTimeline={setOpenDistributionTimeline}
              handleApprovalClick={() => {}}
              cardType={"double"}
              popUpMode={true}
            />
          ) : (
            <div className="flex justify-center items-center w-full py-padding-xl">
              <p className="text-text-secondary text-font-sm">
                No timeline data available.
              </p>
            </div>
          )}
        </LargePopupRedirect>
        // </div>
      )}

      {isLabelPopupOpen && (
        <div
          onClick={(e) => {
            e.stopPropagation();
            setIsLabelPopupOpen(true);
          }}
          className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity"
        >
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated transactions."
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            LabelAccounts={labelTxnId}
            isLabelPopupOpen={isLabelPopupOpen}
            filteredData={accumulatedData
              ?.filter((t) => labelTxnId.includes(t.txn_id))
              ?.map((t) => ({ ...t, id: t.txn_id }))}
            onClose={handleClose}
            loading={labelPopupLoading}
            setLoading={setLabelPopupLoading}
            handleAssignLabels={handleAssignLabelsProp}
            handleUnassignLabels={handleUnassignLabelsProp}
            type="viewall"
          />
        </div>
      )}
      <div className="flex flex-col items-center relative w-width-full h-full-height overflow-hidden">
        <div className="flex flex-col items-center justify-center z-z-index-overlay Qmd:shadow-box-shadow-bottom Qmd:bg-primary-nav bg-primary-nav-act relative w-full">
          <div className="Qmd:min-h-navbar-breadcrumb-height bg-primary-nav"></div>
          <TopNavComponent
            direction={direction}
            BottomHeader="Recreate transaction dashboard"
            BottomSubText="The following transactions were rejected but their data can be used to recreate new ones."
            filteredSearchProps={{
              setShowInnerSearchBar: setShowInnerSearchBar,
              showSearchBar: showSearchBar,
              isFilterDisabled: allScheduleTxnAccountsLoading,
              isSearchDisabled: allScheduleTxnAccountsLoading,
              onSearchInput: handleSearch,
              searchText: searchUserTextDebounce,
              searchPlaceholder: "Search beneficiary transaction",
              filterPlaceholder: "Transaction details",
              filterItems: [
                {
                  name: "Search",
                  isMulti: false,
                  value: txnAddDetails,
                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration?.lengthCheckOne);
                    handleSearch(val);
                    setTxnAddDetails(val);
                  },
                  isDropdown: false,
                  isDisabled: allScheduleTxnAccountsLoading,
                },
                {
                  name: "Owner account",
                  short_name: "Own. Acc",
                  isMulti: false,
                  value: selectedOwnerAccId,
                  displayValue: standardAccountNumberFormat(
                    accountNumber,
                    true,
                  ),
                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setSelectedOwnerAccId(val);
                  },
                  setDisplayValue: setAccountNumber,
                  valueType: "string",
                  isDropdown: true,
                  isDisabled: allScheduleTxnAccountsLoading,
                },
                {
                  name: "Beneficiary account",
                  short_name: "Bene. Acc",
                  isMulti: false,
                  value: selectedBeneAccId,
                  displayValue: accountName || accountNameValue,
                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setSelectedBeneAccId(val);
                  },

                  setDisplayValue: (val) => {
                    setAccountName(val);
                    setAccountNameValue(val);
                  },
                  isDropdown: true,
                  valueType: "string",
                  isDisabled: allScheduleTxnAccountsLoading,
                },
                {
                  name: "Amount",
                  short_name: "Amt - INR",
                  isMulti: false,
                  value: txnAmountFilter,
                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setTxnAmountFilter(val);
                  },
                  displayValue: FormatAmount({ price: txnAmountFilter }),
                  isDropdown: false,
                  isDisabled: allScheduleTxnAccountsLoading,
                  valueType: "number",
                },

                {
                  name: "Category",
                  valueType: "string",
                  short_name: "Cat",
                  isMulti: false,
                  value: currentCategory,
                  displayValue: displayCategory,
                  setValue: (val) => {
                    const c =
                      allCategories.filter((x) => x.id === val)[0]?.name ?? "";
                    setDisplayCategory(c);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setCurrentCategory(val);
                  },
                  isDropdown: true,
                  isDisabled: allScheduleTxnAccountsLoading,
                },
                {
                  name: "Labels",
                  short_name: "Lab",
                  isMulti: true,
                  value: labelsFilter,
                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setFilterLabels(val);
                  },
                  isDropdown: true,
                  valueType: "string",
                  isDisabled: allScheduleTxnAccountsLoading,
                },
              ],
              filters: [
                {
                  name: "Payment method",
                  filterType: "dropdown",
                  variant: "single",
                  value: paymentMethod,
                  dropdownType: "PaymentMethod",
                  options: ["NEFT", "RTGS"],
                  dropdownPlaceHolder: "Select type",
                  isDisabled: allScheduleTxnAccountsLoading,
                  statusPop: true,
                  handleChange: (value) => {
                    setCurrentPage(GlobalConfiguration?.lengthCheckOne);
                    setPaymentMethod(value);
                    handlePaymentMethod(value);
                  },
                },
                {
                  name: "Show/hide confidential transactions",
                  filterType: "dropdown",
                  variant: "single",
                  value: confidentialMethod,
                  options: ["Show only confidential", "Hide confidential"],
                  dropdownPlaceHolder: "Select type",
                  isDisabled: allScheduleTxnAccountsLoading,
                  statusPop: true,
                  handleChange: (value) => {
                    setCurrentPage(GlobalConfiguration?.lengthCheckOne);
                    setConfidentialMethod(value);
                    handleConfidentialMethod(value);
                  },
                },
                {
                  name: "Date range",
                  filterType: "calender",
                  variant: "range",
                  size: "small",
                  value:
                    (startDate && endDate) ||
                    (startDateFilter && endDateFilter),
                  isDisable: allScheduleTxnAccountsLoading,
                  startDate:
                    startDate ||
                    (startDateFilter
                      ? new Date(
                          startDateFilter *
                            IntervalConfiguration.intervalMedium,
                        )
                      : null),
                  endDate:
                    endDate ||
                    (endDateFilter
                      ? new Date(
                          endDateFilter * IntervalConfiguration.intervalMedium,
                        )
                      : null),
                  handleChange: (dates) => {
                    const [start, end] = dates || [];

                    if (!start && !end) {
                      const [defaultStart, defaultEnd] = getDefaultWeekSpan();

                      setStartDate(defaultStart);
                      setEndDate(defaultEnd);

                      setStartDateFilter(defaultStart.getTime());
                      setEndDateFilter(defaultEnd.getTime());

                      handleFilterDateRange(
                        defaultStart.getTime(),
                        defaultEnd.getTime(),
                      );

                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      return;
                    }

                    setStartDate(start);
                    setEndDate(end);
                    if (start && end) {
                      handleFilterDateRange(
                        Math.floor(start.getTime()),
                        Math.floor(end.getTime()),
                      );
                    }
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  },
                },

                // {
                //   name: "Created via",
                //   filterType: "dropdown",
                //   variant: "single",
                //   value: createdVia,
                //   options: ["Manual", "Scheduled"],
                //   dropdownPlaceHolder: "Select type",
                //   isDisabled: false,
                //   handleChange: (value) => {
                //     setCurrentPage(GlobalConfiguration?.lengthCheckOne);
                //     setCreatedVia(value);
                //     handleCreatedVia(value);
                //   },
                // },
              ],
              isSearchClearAllDisabled: !(
                searchUserTextDebounce?.length ||
                loading ||
                currentCategory !== "" ||
                displayCategory !== "" ||
                txnAmountFilter !== "" ||
                labelsFilter?.length > GlobalConfiguration?.lengthCheckZero ||
                selectedBeneAccId !== "" ||
                selectedOwnerAccId !== "" ||
                txnAddDetails !== ""
              ),
              isFilterClearAllDisabled: !(
                allScheduleTxnAccountsLoading ||
                paymentMethod?.length > GlobalConfiguration?.lengthCheckZero ||
                confidentialMethod?.length >
                  GlobalConfiguration?.lengthCheckZero ||
                (startDateFilter && endDateFilter)
              ),
              inputData: inputData,
              active: active,
              setActive: setActive,
              loading: loadingData,
              setLoading: setLoadingData,
              isShowFilter: true,
            }}
          />
        </div>

        <div
          className={`flex flex-col items-center w-width-full h-height-full bg-primary-bg mb-[var(--pagination-height)] ${
            showInnerSearchBar
              ? "overflow-y-hidden  cursor-pointer-none pointer-events-none"
              : "overflow-auto"
          }`}
          onScroll={handleScroll}
        >
          {allScheduleTxnAccountsLoading ? (
            <div
              className={`m-auto justify-center items-center flex ${
                showInnerSearchBar
                  ? "overflow-y-hidden cursor-pointer-none pointer-events-none"
                  : ""
              }`}
            >
              {showInnerSearchBar && (
                <div className="absolute bg-PopUp-BackDrop top-top-base opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"></div>
              )}
              <Loader />
            </div>
          ) : accumulatedData?.length > GlobalConfiguration?.lengthCheckZero ? (
            <div
              className="scroll flex flex-col w-width-full items-center justify-center"
              ref={filterRef}
            >
              {showInnerSearchBar && (
                <div className="absolute bg-PopUp-BackDrop top-top-base opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"></div>
              )}

              <div className="fixed w-full bottom-bottom-base bg-primary-nav z-z-index-tooltip">
                {showInnerSearchBar && (
                  <div className="absolute bg-PopUp-BackDrop top-top-base opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"></div>
                )}
                <PaginationComponent
                  handleSelect={handleSelect}
                  selectedValue={selectedValue}
                  data={mainData}
                  pageSize={pageSize}
                  dropdownOptions={dropdownOptions}
                  handlePagination={handlePagination}
                  currentPage={currentPage}
                  setIsOpen={setIsOpen}
                />
              </div>

              <div className="scroll flex flex-col items-center justify-center w-width-full lg:w-auto px-padding-md lg:px-padding-base pb-padding-md">
                {shouldShowBankingHoursAlert && (
                  <div className="max-w-tab-width-normal w-full Qlg:mx-auto mt-5 ">
                    <CommonAlertCard
                      title="Functioning outside banking hours"
                      texts="Transactions will be processed automatically during the next bank working day. Learn more"
                      highlightedText={["Learn more"]}
                      onHighlightedTextClick={(event, index) => {
                        if (index === 0) {
                          setShowBankingHoursPopup(true);
                        }
                      }}
                    />
                  </div>
                )}
                {accumulatedData
                  ?.filter(
                    (account) => account?.lifecycle_status !== "abandoned",
                  )
                  ?.map((account, index) => (
                    <div
                      key={account?.txn_id}
                      className={`beneTxn_recreate_data_card w-width-full mt-margin-md ${isSidebarOpen ? "opacity-light-opacity" : ""}`}
                    >
                      <CommonTransactionApprovalCard
                        entries={[
                          [
                            {
                              type: "textSubtextX2",
                              text: `INR ${FormatAmount({
                                price: account?.amount || "0",
                              })}`,
                              isBold: true,
                              subText: "Amount",
                              textColor: "var(--settled)",
                              text1:
                                account?.category_id?.category_name ||
                                "Not available",
                              subText1: "Category",
                            },
                            {
                              type: "textSubtext",
                              text: account?.beneficiary_account_name
                                ?.toLowerCase()
                                ?.split(" ")
                                ?.map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() +
                                    word.slice(1),
                                )
                                ?.join(" "),
                              subText: "Account name",
                              icon:
                                account?.confidential_transaction === "Y" &&
                                ICONS?.CONFIDENTIAL_TRANSACTION,
                            },
                            {
                              type: "cta",
                              text: account?.labels?.length
                                ? account?.labels.join(", ")
                                : "No labels assigned",
                              subText: "Labels",
                              onClick: (e) => {
                                if (
                                  services?.includes("ALabel") &&
                                  services?.includes("RLabel")
                                ) {
                                  e.stopPropagation();
                                  setLabelTxnId([account?.txn_id]);
                                  setSelectedLabels(account?.labels || []);
                                  setIsLabelPopupOpen(true);
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "ALabel,RLabel",
                                    },
                                  });
                                }
                              },
                            },
                          ],
                        ]}
                        ctaBtn2Text="Approval history"
                        ctaBtn2OnClick={(e) => {
                          if (!isSidebarOpen) {
                            e.stopPropagation();
                            openTimelineModal(account?.txn_id);
                            setTxnId(account?.txn_id);
                          }
                        }}
                        ctaBtn1Text="More details"
                        ctaBtn1OnClick={(e) => {
                          if (!isSidebarOpen) {
                            e.stopPropagation();
                            openRefactorTxnDetailModal();
                            setTxnId(account?.txn_id);
                          }
                        }}
                        alerts={[]}
                        cardState="default"
                        thisIsARecreateCard
                        ownerAccountNumber={account?.owner_account_bank_acc_no}
                        ownerAccountIfsc={
                          account?.owner_account_ifsc_code || ""
                        }
                        ownerAccountNumberSubtext="Source account"
                        ownerAccountBalance={
                          account?.owner_account_balance ?? "Not available"
                        }
                        ownerAccountBalanceSubtext={`Balance - ${
                          account?.owner_account_balance_last_fetched_at_in_words ||
                          "Not available"
                        }`}
                        ownerAccountBalanceOnClick={(e) => {
                          handleRefresh(
                            e,
                            account?.owner_account_id,
                            account?.owner_account_balance,
                          );
                        }}
                        destinationAccountNumber={
                          account?.beneficiary_account_bank_acc_no
                        }
                        destinationAccountIfsc={
                          account?.beneficiary_account_ifsc_code || ""
                        }
                        destinationAccountNumberSubtext="Destination account"
                        destinationAccountText={
                          account?.beneficiary_account_ifsc_code
                        }
                        destinationAccountSubtext="IFSC"
                        createdOnRequired={false}
                        recreateOnClick={() => {
                          if (!hasModService) {
                            navigate("/feature_not_assigned", {
                              state: { unavailableService: "CBeneficiaryTxn" },
                            });
                          } else if (!isSidebarOpen) {
                            sessionStorage.setItem(
                              "recreate_ben",
                              JSON.stringify({
                                txn_id: account?.txn_id,
                                type: "refactorFlow",
                              }),
                            );

                            navigate(
                              "/beneficiary_transaction_dashboard/create_beneficiary_transaction",
                              {
                                state: {
                                  txn_id: account?.txn_id,
                                  type: "refactorFlow",
                                },
                              },
                            );
                          }
                        }}
                        recreateBtnText="Recreate transaction"
                        recreateBtnIsDisabled={!hasModService}
                      />
                    </div>
                  ))}
              </div>
            </div>
          ) : noResultsAfterFilter || noTransactionsFromAPI ? (
            <div className="w-width-full h-full flex items-center justify-center">
              {showInnerSearchBar && (
                <div className="absolute bg-PopUp-BackDrop top-top-base opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none" />
              )}
              <div className="w-width-full h-full flex items-center justify-center">
                <div className="flex flex-col items-center gap-gap-sm">
                  <img
                    src={
                      noResultsAfterFilter
                        ? ICONS?.NO_DATA_FOUND
                        : ICONS?.NO_PENDING_TRANSACTION
                    }
                    alt="No accounts found"
                    className="w-graphic-width-md h-graphic-rectangle-height-md"
                  />

                  <p className="text-text-primary text-center text-font-sm pt-padding-sm items-center">
                    {noResultsAfterFilter
                      ? "No data found."
                      : "There are no transactions left to recreate."}
                  </p>

                  <PrimaryButton
                    btnText={emptyStateButton.btnText}
                    handleFunction={emptyStateButton.handleFunction}
                    enabledBgColor={emptyStateButton.enabledBgColor}
                    enabledTextColor="var(--text-primary)"
                  />
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default BeneficiaryTransactionRecreateDashboard;
